/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierRestrictionDirection {
  Pickup = "pickup",
  Delivery = "delivery",
  Both = "both",
}

export function instanceOfCarrierRestrictionDirection(value: any): boolean {
  for (const key in CarrierRestrictionDirection) {
    if (
      Object.prototype.hasOwnProperty.call(CarrierRestrictionDirection, key)
    ) {
      if (
        CarrierRestrictionDirection[
          key as keyof typeof CarrierRestrictionDirection
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierRestrictionDirectionFromJSON(
  json: any,
): CarrierRestrictionDirection {
  return CarrierRestrictionDirectionFromJSONTyped(json, false);
}

export function CarrierRestrictionDirectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierRestrictionDirection {
  return json as CarrierRestrictionDirection;
}

export function CarrierRestrictionDirectionToJSON(
  value?: CarrierRestrictionDirection | null,
): any {
  return value as any;
}

export function CarrierRestrictionDirectionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierRestrictionDirection {
  return value as CarrierRestrictionDirection;
}
